// extracted by mini-css-extract-plugin
export default {"add-feedback-history-modal":"AddFeedbackHistoryModal_add-feedback-history-modal__Qywgi"};